module.exports = __webpack_public_path__ + "static/img/vg.b37358a1.svg";